export default __webpack_public_path__ + "static/media/feather _ arrow-down.7dba2e74.svg";